import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectDecoratedDeliveryOptions } from 'src/redux/delivery/selectors';
import type {
  DeliverySectionDispatchProps,
  DeliverySectionStateProps,
} from '../../components/DeliverySection/DeliverySection';
import { DeliverySection } from '../../components/DeliverySection/DeliverySection';

const mapStateToProps = (state: ReduxApplicationState): DeliverySectionStateProps => {
  const { delivery } = state;

  return {
    deliveryOptions: selectDecoratedDeliveryOptions(state),
    loading: delivery.deliveryZoneOptionsLoading || delivery.partnerDeliverySettingsLoading,
    partnerFreeDeliveryThreshold: delivery.partnerFreeDeliveryThreshold,
    partnerName: state.product.partner.name,
  };
};

const mapDispatchToProps = (): DeliverySectionDispatchProps => {
  return {
    onVisible: () => {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Delivery Information',
        event_action: 'Impression',
        event_label: 'not set',
      });
    },
  };
};

export const DeliverySectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliverySection);
